import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface StructuredSearchPageHeaderProps {
  title: string;
  showBackButton?: boolean;
  onBack: () => void;
  controls: ReactNode;
}

export const StructuredSearchPageHeader = ({
  title,
  showBackButton = true,
  onBack,
  controls,
}: StructuredSearchPageHeaderProps) => (
  <div className="flex min-w-0 flex-col items-start gap-3 [@media(min-width:1281px)]:flex-row [@media(min-width:1281px)]:items-center [@media(min-width:1281px)]:justify-between">
    <div className="flex min-w-0 shrink-0 items-center gap-1">
      {showBackButton && (
        <>
          <BasicTooltip content="Go back">
            <Button
              type="button"
              variant="ghost"
              size="tinyIcon"
              className="h-7 w-7 flex-shrink-0 text-gray-600 hover:text-gray-900"
              aria-label="Go back"
              onClick={onBack}
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </BasicTooltip>
          <span
            className="shrink-0 select-none px-1 text-2xl font-light leading-tight text-gray-300"
            aria-hidden
          >
            |
          </span>
        </>
      )}
      <div
        className={`min-w-0 truncate whitespace-nowrap text-xl leading-tight text-gray-900 sm:text-2xl ${
          showBackButton ? "" : "pl-0"
        }`}
      >
        {title}
      </div>
    </div>
    {controls}
  </div>
);
